module.exports = __webpack_public_path__ + "img/Save_money_and_time_with_a_headless_CMS.142a403e.jpeg";